import { render } from "./AddTagModal.vue?vue&type=template&id=69404a89&scoped=true"
import script from "./AddTagModal.vue?vue&type=script&lang=js"
export * from "./AddTagModal.vue?vue&type=script&lang=js"

import "./AddTagModal.vue?vue&type=style&index=0&id=69404a89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69404a89"]])

export default __exports__